import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { UIRouterModule } from '@uirouter/angular';
import { ChatComponent } from './chat.component';
import { ChatRoute } from './chat.route';
import { QueryService } from './query.service';
import { ChatFeatureComponent } from './chat-feature/chat-feature.component';


@NgModule({
    declarations: [
        ChatComponent,
        ChatFeatureComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        UIRouterModule.forChild({
            states: [ChatRoute]
        })
    ],
    providers: [
        QueryService
    ],
    exports: [ChatComponent, ChatFeatureComponent]
})
export class ChatModule {}